module.exports = __webpack_public_path__ + "media/packs/images/flags/DJ-6244ba82976c17dfba861c0ac58135ab.svg";